export default "/images/black-days-bg.png?8241f35cc7e5f75ab5cdfc31b9ae72b8";